<template>
	<section>
		<compFormEdit class="margin-layout" ref="formbase" :formdata="getBase" v-model="formData"></compFormEdit>
		<vButtonGroup class="text-right">
			<vButton
				v-for="item in getStatusBtns"
				:key="item.name"
				@click="item.run"
				:theme="item.theme"
			>{{item.name}}</vButton>
		</vButtonGroup>
		<compModal
			v-model="modalProps.show"
			v-bind="modalProps"
			@on-close="modalProps.show=false"
			@on-confirm="modalProps.show=false"
		>
			<component
				v-if="modalProps.component"
				:is="modalProps.component"
				v-bind="modalProps.props"
				v-on="modalProps.on"
			/>
		</compModal>
		<vLoading size="large" transfer :loading="loading"></vLoading>
	</section>
</template>

<script>
import { mapGetters } from 'vuex';
import { HttpSaveWorkOrder, HttpWorkOrderInfo } from '@/service/workorder';
import { HttpNewGetCusOrgWareList, } from '@/service/billing';
import mixin from "./mixin";
import compPlan from "./plan";
export default {
	mixins: [mixin],
	components: {
		compPlan,
	},
	data() {
		return {
			loading: false,
			// type: this.$route.params.type,
			// id: this.$route.query.id,
			formData: {

			},
			modalProps: {
				show: false,
			},
			cusWareList: [],

		};
	},
	computed: {
		...mapGetters('dictionary', ['getSelfmanageorgList', 'getCusproductList', 'getBillcusWareList', 'getWarehouseList']),
		/**
		 * 根据状态显示不同按钮
		 */
		getStatusBtns() {
			return [{
				name: '下一步',
				theme: 'primary',
				show: true,
				run: this.save
			}, {
				name: '返回',
				theme: 'default',
				show: true,
				run: this.cancel
			}]
		},

		getBase() {
			return [{
				label: "来源单号",
				key: "sourceNo",
				required: false,
			}, {
				label: "事务处理计划单号",
				key: "workOrderPlanNo",
				tag: "vInput",
				props: {
					suffix: "search",
					readonly: true
				},
				on: {
					'on-icon-click': this.handleModal
				},
				required: false,
			},
			{
				label: "关联单据类型",
				key: "relationOrderTypeId",
				tag: 'vSelect',
				options: this.getRelativeOrderTypes.slice(0,this.getRelativeOrderTypes.length-1),
				required: false,
			},
			{
				label: "关联单据号",
				key: "orderNo",
				required: false,
				on: {
					'on-blur': () => {
						this.getWorkOrderInfo()
					}
				},
			},
			{
				label: "客户组织",
				key: "organizationId",
				tag: 'vSelect',
				options: this.getSelfmanageorgList,
				props: {
					filterable: true,
				}
			},
			{
				label: "仓库",
				key: "orgWarehouseId",
				tag: 'vSelect',
				options: this.cusWareList,
				props: {
					filterable: true,
				}
			},
			{
				label: "项目",
				key: "lineId",
				tag: 'vSelect',
				options: this.getCusproductList,
				required: false,
				props: {
					filterable: true,
				}
			},
			{
				label: "备注",
				key: "remark",
				tag: 'vTextarea',
				required: false,
			},
			];
		},
	},
	watch: {
		'formData.organizationId'(val) {
			this.getWareList(val)
		},
		'formData.relationOrderTypeId'() {
			this.getWorkOrderInfo()
		},
		// 'formData.orderNo'() {
		// 	this.getWorkOrderInfo()
		// }
	},
	methods: {
		getWareList(val) {
			this.cusWareList = [];
			HttpNewGetCusOrgWareList({ customerOrgId: val }).then(res => {
				this.cusWareList = res.data.map(item => {
					return {
						value: item.id,
						label: item.code + ' (' + item.title + ')'
					}
				})
			}, err => {
				this.cusWareList = [];
				this.$VMessage.error(err.message);
			})
		},
		// 详情操作
		handleModal() {
			//选择调拨计划单
			this.modalProps = {
				show: true,
				title: '查找事务计划',
				component: "compPlan",
				width: 'large',
				showFooter: false,
				props: {
					initFormData: {
						'search[IN_workOrderPlanStatus]': '20,30'
					}
				},
				on: {
					'on-data': (row) => {
						this.formData = {
							...this.formData,
							lineId: row.lineId,
							// orgWarehouseId: row.orgWarehouseId,
							orgWarehouseId: row.orgWarehouseId,
							orderNo: row.orderNo,
							relationOrderTypeId: row.relationOrderTypeId,
							organizationId: row.organizationId,
							workOrderPlanId: row.id,
							workOrderPlanNo: row.workOrderPlanNo
						}
						this.modalProps = {};
					}
				}
			}
		},
		//事务执行单-根据单据类型和单号获得相关信息
		async getWorkOrderInfo() {
			const { relationOrderTypeId, orderNo, workOrderPlanNo } = this.formData;
			if (!relationOrderTypeId || !orderNo || workOrderPlanNo) return;
			HttpWorkOrderInfo({
				orderType: relationOrderTypeId,
				orderNo: orderNo,
			}).then(res => {
				this.formData = {
					...this.formData,
					...res.data
				}
				this.formData.organizationId = this.formData.orgId
			}).catch(err => {
				this.$VMessage.error(this.$t(err.langCode, { defaultValue: err.message }));
			})
		},
		//更新单据数据
		async save() {
			const valid = await this.$refs.formbase.validate();
			if (!valid) return;
			this.loading = true;
			HttpSaveWorkOrder(this.formData).then(res => {
				this.$router.push({
					name: 'workorderorderUpdate',
					params: {
						type: 'edit'
					},
					query: {
						id: res.data.id
					}
				})
			}).catch(err => {
				this.loading = false;
				this.$VMessage.error(this.$t(err.langCode, { defaultValue: err.message }));
			})
		},
		cancel() {
			this.$emit('on-close')
		}
	}
};
</script>
